import useFooterLinks from 'modules/header/components/footer-links'
import styled from 'styled-components'

const YEAR = new Date().getFullYear()

const Container = styled.div`
    margin-top: 50px;
    text-align: center;
    font-size: 15px;
`

const Copyright = styled.div`
    display: inline-block;
    font-family: 'nexablack', sans-serif;
    margin-right: 30px;
`

const Links = styled.div`
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    display: inline-block;

    a {
        margin-left: 30px;
    }
`

const Footer = () => {
    const footerLinks = useFooterLinks()

    return (
        <Container>
            <Copyright>{YEAR} GIPHY, Inc.</Copyright>
            <Links>
                {footerLinks.map(({ url, label }) => (
                    <a key={label.toLowerCase().replace(/ /g, '-')} href={url} target="_blank" rel="noreferrer">
                        {label}
                    </a>
                ))}
            </Links>
        </Container>
    )
}

export default Footer
